import React from "react";
import { Outlet } from "react-router-dom";
import HeaderKnowledge from "../header/HeaderKnowledge";

export default function Layout() {
  return (
    <div className="knowledge-content">
      <header className="main-header knowledge-header flex-group flex-start flex-align-center">
        <HeaderKnowledge />
      </header>
      <main>
        <Outlet />
      </main>
    </div>
  );
}
